import React from "react";
import { useParams } from "react-router-dom";
import ProductGrid from "./home/ProductGrid";
import SEO from "./SEO";

const Shop = () => {
  const { categoryId, categoryName } = useParams(); // 👈 Get category name + id

  return (
    <div>
         <SEO
  title={

    `${categoryName || "Products"} | Your Brand`
  }
  description={

    `Browse ${categoryName || "our"} products at best prices`
  }
  keywords={
    categoryName ||
 
    "custom patches"
  }
/>
      <ProductGrid categoryId={categoryId} categoryName={categoryName} />
      
    </div>
  );
};

export default Shop;
